import { FileText, Loader2 } from 'lucide-react';

import { OpenPdfInNewWindow } from '../components/open-pdf-new-window';

// Right-pane document preview for the review dialog. The operator edits values
// on the left and renders the Draft here with Save & preview — the document
// stays inside the dialog instead of opening in a separate browser tab.
function PreviewBody({
  previewUrl,
  isPreviewing,
}: Readonly<{ previewUrl: string | null; isPreviewing: boolean }>) {
  if (isPreviewing) {
    return (
      <div className="bg-muted/30 text-muted-foreground flex flex-1 items-center justify-center rounded-md border text-sm">
        <Loader2 className="mr-2 size-4 animate-spin" aria-hidden /> Rendering preview…
      </div>
    );
  }
  if (previewUrl === null) {
    return (
      <div
        className="bg-muted/30 text-muted-foreground flex flex-1 flex-col items-center justify-center gap-2 rounded-md border border-dashed p-6 text-center text-sm"
        data-testid="invoice-review-preview-empty"
      >
        <FileText className="size-8" aria-hidden />
        <p>Save &amp; preview to render the document here.</p>
      </div>
    );
  }
  return (
    <div className="flex flex-1 flex-col gap-2">
      <iframe
        src={previewUrl}
        title="Invoice document preview"
        className="min-h-[20rem] flex-1 rounded-md border"
        data-testid="invoice-review-preview"
      />
      <OpenPdfInNewWindow url={previewUrl} />
    </div>
  );
}

export function InvoiceReviewPreviewPane({
  previewUrl,
  isPreviewing,
}: Readonly<{ previewUrl: string | null; isPreviewing: boolean }>) {
  return (
    <section
      aria-labelledby="review-preview-heading"
      className="flex min-h-0 flex-1 flex-col gap-3"
    >
      <h3 id="review-preview-heading" className="text-sm font-semibold">
        Document preview
      </h3>
      <p className="text-muted-foreground text-xs">
        Non-authoritative — marked “preview” and never issued.
      </p>
      <PreviewBody previewUrl={previewUrl} isPreviewing={isPreviewing} />
    </section>
  );
}
